import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { useState, useEffect } from "react";

import img13 from "../assets/images/img13.avif";
import img14 from "../assets/images/img14.avif";
import img15 from "../assets/images/img15.avif";
import img16 from "../assets/images/img16.avif";

const STATS = [
  { number: "2014", label: "Established" },
  { number: "300+", label: "Skilled Employees" },
  { number: "500+", label: "Properties Served" },
  { number: "UAE", label: "Wide Coverage" },
];

const VMV = [
  {
    icon: (
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
        <line x1="12" y1="2" x2="12" y2="4"/><line x1="12" y1="20" x2="12" y2="22"/>
        <line x1="2" y1="12" x2="4" y2="12"/><line x1="20" y1="12" x2="22" y2="12"/>
      </svg>
    ),
    title: "Our Vision",
    text: "To be the most trusted and reputed technical contracting company in the UAE — delivering world-class construction and engineering services that shape the future of Dubai and beyond.",
    highlight: false,
  },
  {
    icon: (
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/>
      </svg>
    ),
    title: "Our Mission",
    text: "To deliver best-in-class technical services across building maintenance, contracting, and engineering — completing every project on time, within budget, and to the highest quality standards while ensuring complete client satisfaction.",
    highlight: true,
  },
  {
    icon: (
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
      </svg>
    ),
    title: "Our Values",
    text: "Transparency in every deal, commitment to every promise, reliability across 500+ properties, safety on every site, and long-term relationships built on mutual trust and professional excellence.",
    highlight: false,
  },
];

const WHY_US = [
  {
    icon: (<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#1a6ab5" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>),
    title: "Licensed & Certified",
    desc: "Fully licensed contractor operating under UAE regulations with all required certifications and trade approvals.",
  },
  {
    icon: (<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#1a6ab5" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>),
    title: "On-Time Delivery",
    desc: "We respect deadlines. Our structured workflow ensures every project is completed on schedule without compromising quality.",
  },
  {
    icon: (<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#1a6ab5" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>),
    title: "Expert Workforce",
    desc: "Over 300 skilled professionals across multiple disciplines — from engineers to specialist technicians.",
  },
  {
    icon: (<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#1a6ab5" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>),
    title: "500+ Properties Served",
    desc: "Trusted by over 500 properties and world-renowned organisations including DAMAC, MERAAS, and Freyssinet Middle East.",
  },
  {
    icon: (<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#1a6ab5" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>),
    title: "UAE-Wide Operations",
    desc: "Operating across all of UAE with headquarters in Ras Al Khor Industrial Area, Dubai — ready to mobilise anywhere.",
  },
  {
    icon: (<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#1a6ab5" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>),
    title: "Safety First",
    desc: "Strict safety standards are maintained on every site. Our teams are trained and equipped to operate safely and responsibly.",
  },
];

export default function About() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <div style={{ fontFamily: "'Barlow', sans-serif", background: "#f0f7ff", minHeight: "100vh" }}>
      <link href="https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;600;700;800;900&family=Barlow:wght@400;500;600;700&display=swap" rel="stylesheet" />

      <style>{`
        @keyframes fadeUp { from { opacity:0; transform:translateY(30px); } to { opacity:1; transform:translateY(0); } }
        @keyframes fadeLeft { from { opacity:0; transform:translateX(-40px); } to { opacity:1; transform:translateX(0); } }
        @keyframes fadeRight { from { opacity:0; transform:translateX(40px); } to { opacity:1; transform:translateX(0); } }
        .why-card:hover { transform:translateY(-5px) !important; box-shadow:0 16px 40px rgba(26,106,181,0.14) !important; border-bottom-color:#e8a800 !important; }
        @media(max-width:768px){ .about-content-grid{ grid-template-columns:1fr !important; } .vmv-grid{ grid-template-columns:1fr !important; } }
      `}</style>

      <Navbar />

      {/* HERO */}
      <section style={{ position:"relative", height:340, overflow:"hidden", display:"flex", alignItems:"center", paddingTop:72 }}>
        <img src={img13} alt="About Us" style={{ position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"cover", objectPosition:"center" }} />
        <div style={{ position:"absolute", inset:0, background:"linear-gradient(135deg,rgba(13,60,110,0.82) 0%,rgba(26,106,181,0.65) 100%)" }} />
        <div style={{ position:"relative", zIndex:2, maxWidth:1200, margin:"0 auto", padding:"0 24px", opacity:visible?1:0, animation:visible?"fadeLeft 0.8s ease forwards":"none" }}>
          <h1 style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:"clamp(40px,6vw,72px)", fontWeight:900, color:"#fff", margin:"0 0 14px", textTransform:"uppercase", letterSpacing:-1 }}>About Us</h1>
          <div style={{ display:"flex", alignItems:"center", gap:8 }}>
            <a href="/" style={{ color:"rgba(255,255,255,0.65)", fontSize:14, textDecoration:"none" }}
              onMouseEnter={e => e.currentTarget.style.color="#fff"}
              onMouseLeave={e => e.currentTarget.style.color="rgba(255,255,255,0.65)"}
            >Home</a>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            <span style={{ color:"#e8a800", fontSize:14, fontWeight:600 }}>About Us</span>
          </div>
        </div>
      </section>

      {/* ABOUT CONTENT */}
      <section style={{ background:"#fff", padding:"72px 24px" }}>
        <div className="about-content-grid" style={{ maxWidth:1100, margin:"0 auto", display:"grid", gridTemplateColumns:"1fr 1fr", gap:64, alignItems:"center" }}>
          <div style={{ animation:visible?"fadeLeft 0.9s ease forwards":"none", opacity:visible?1:0 }}>
            <div style={{ color:"#1a6ab5", fontWeight:700, fontSize:12, letterSpacing:3, textTransform:"uppercase", marginBottom:12 }}>Who We Are</div>
            <h2 style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:"clamp(30px,4vw,48px)", fontWeight:900, color:"#0d3c6e", margin:"0 0 24px", lineHeight:1.1, textTransform:"uppercase" }}>About Us</h2>
            <p style={{ color:"#3a6080", fontSize:15.5, lineHeight:1.95, margin:"0 0 16px" }}>
              We established in the UAE since 2014, Dubai-based. Unique Engineers Building Contracting LLC is providing technical services in all over the UAE. We are specialised in Building Maintenance & Cleaning services.
            </p>
            <p style={{ color:"#3a6080", fontSize:15.5, lineHeight:1.95, margin:"0 0 16px" }}>
              We have skilled workforce of more than 300 employees. Unique Engineers offices are located in Ras Al Khor Industrial Area-1st, Dubai, UAE.
            </p>
            <p style={{ color:"#3a6080", fontSize:15.5, lineHeight:1.95, margin:"0 0 32px" }}>
              We are delivering professional technical services for over 500 properties to high quality, world-renowned organisations such as DAMAC Group, MERAAS, ARJ (Ahmed Ramadhan Juma) Group, City Solar Energy Systems LLC, Freyssinet Middle East & many more business tycoon in the industry.
            </p>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:1, borderRadius:10, overflow:"hidden", boxShadow:"0 2px 16px rgba(26,106,181,0.1)" }}>
              {STATS.map((s, i) => (
                <div key={i} style={{ background:i%2===0?"#1a6ab5":"#0d3c6e", padding:"16px 10px", textAlign:"center" }}>
                  <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:26, fontWeight:900, color:"#e8a800", lineHeight:1 }}>{s.number}</div>
                  <div style={{ fontSize:10, color:"rgba(255,255,255,0.7)", marginTop:4, textTransform:"uppercase", letterSpacing:0.5 }}>{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div style={{ position:"relative", height:480, animation:visible?"fadeRight 0.9s ease forwards":"none", opacity:visible?1:0 }}>
            <div style={{ position:"absolute", top:0, left:0, width:"62%", height:"58%", borderRadius:16, overflow:"hidden", boxShadow:"0 16px 48px rgba(26,106,181,0.2)", border:"3px solid #fff", zIndex:2, transition:"transform 0.35s, box-shadow 0.35s" }}
              onMouseEnter={e => { e.currentTarget.style.transform="scale(1.03)"; e.currentTarget.style.boxShadow="0 24px 64px rgba(26,106,181,0.3)"; }}
              onMouseLeave={e => { e.currentTarget.style.transform="scale(1)"; e.currentTarget.style.boxShadow="0 16px 48px rgba(26,106,181,0.2)"; }}
            >
              <img src={img14} alt="About 1" style={{ width:"100%", height:"100%", objectFit:"cover", transition:"transform 0.5s" }}
                onMouseEnter={e => e.currentTarget.style.transform="scale(1.07)"}
                onMouseLeave={e => e.currentTarget.style.transform="scale(1)"}
              />
            </div>
            <div style={{ position:"absolute", top:0, right:0, width:"35%", height:"38%", borderRadius:16, overflow:"hidden", boxShadow:"0 16px 48px rgba(26,106,181,0.2)", border:"3px solid #fff", zIndex:2, transition:"transform 0.35s, box-shadow 0.35s" }}
              onMouseEnter={e => { e.currentTarget.style.transform="scale(1.04)"; e.currentTarget.style.boxShadow="0 24px 64px rgba(26,106,181,0.3)"; }}
              onMouseLeave={e => { e.currentTarget.style.transform="scale(1)"; e.currentTarget.style.boxShadow="0 16px 48px rgba(26,106,181,0.2)"; }}
            >
              <img src={img15} alt="About 2" style={{ width:"100%", height:"100%", objectFit:"cover", transition:"transform 0.5s" }}
                onMouseEnter={e => e.currentTarget.style.transform="scale(1.07)"}
                onMouseLeave={e => e.currentTarget.style.transform="scale(1)"}
              />
            </div>
            <div style={{ position:"absolute", bottom:0, right:0, width:"78%", height:"38%", borderRadius:16, overflow:"hidden", boxShadow:"0 16px 48px rgba(26,106,181,0.2)", border:"3px solid #fff", zIndex:3, transition:"transform 0.35s, box-shadow 0.35s" }}
              onMouseEnter={e => { e.currentTarget.style.transform="scale(1.03)"; e.currentTarget.style.boxShadow="0 24px 64px rgba(26,106,181,0.3)"; }}
              onMouseLeave={e => { e.currentTarget.style.transform="scale(1)"; e.currentTarget.style.boxShadow="0 16px 48px rgba(26,106,181,0.2)"; }}
            >
              <img src={img16} alt="About 3" style={{ width:"100%", height:"100%", objectFit:"cover", transition:"transform 0.5s" }}
                onMouseEnter={e => e.currentTarget.style.transform="scale(1.07)"}
                onMouseLeave={e => e.currentTarget.style.transform="scale(1)"}
              />
            </div>
            <div style={{ position:"absolute", bottom:-8, left:0, height:5, width:"45%", background:"#e8a800", borderRadius:3 }} />
          </div>
        </div>
      </section>

      {/* VISION MISSION VALUES */}
      <section style={{ background:"#f0f7ff", padding:"72px 24px" }}>
        <div style={{ maxWidth:1100, margin:"0 auto" }}>
          <div style={{ textAlign:"center", marginBottom:52 }}>
            <div style={{ color:"#1a6ab5", fontWeight:700, fontSize:12, letterSpacing:3, textTransform:"uppercase", marginBottom:12 }}>Our Foundation</div>
            <h2 style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:"clamp(30px,4vw,48px)", fontWeight:900, color:"#0d3c6e", margin:0, textTransform:"uppercase" }}>Vision, Mission & Values</h2>
          </div>
          <div className="vmv-grid" style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:0, borderRadius:16, overflow:"hidden", boxShadow:"0 8px 40px rgba(26,106,181,0.14)" }}>
            {VMV.map((item, i) => (
              <div key={i} style={{ background:item.highlight?"#e8a800":"#0d3c6e", padding:"48px 32px", textAlign:"center", transition:"transform 0.3s", cursor:"default" }}
                onMouseEnter={e => e.currentTarget.style.transform="translateY(-4px)"}
                onMouseLeave={e => e.currentTarget.style.transform="translateY(0)"}
              >
                <div style={{ color:item.highlight?"#0d3c6e":"#e8a800", marginBottom:24, display:"flex", justifyContent:"center" }}>{item.icon}</div>
                <h3 style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:800, fontSize:22, color:item.highlight?"#0d3c6e":"#e8a800", margin:"0 0 16px", textTransform:"uppercase", letterSpacing:0.5 }}>{item.title}</h3>
                <p style={{ color:item.highlight?"rgba(13,60,110,0.88)":"rgba(255,255,255,0.85)", fontSize:14.5, lineHeight:1.85, margin:0 }}>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* WHY CHOOSE US */}
      <section style={{ background:"#fff", padding:"72px 24px" }}>
        <div style={{ maxWidth:1100, margin:"0 auto" }}>
          <div style={{ textAlign:"center", marginBottom:48 }}>
            <div style={{ color:"#1a6ab5", fontWeight:700, fontSize:12, letterSpacing:3, textTransform:"uppercase", marginBottom:12 }}>Our Strengths</div>
            <h2 style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:"clamp(30px,4vw,48px)", fontWeight:900, color:"#0d3c6e", margin:"0 0 14px", textTransform:"uppercase" }}>Why Choose Us</h2>
            <p style={{ color:"#3a6080", fontSize:15, maxWidth:520, margin:"0 auto" }}>We bring experience, reliability, and technical excellence to every project we undertake across the UAE.</p>
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))", gap:24 }}>
            {WHY_US.map((item, i) => (
              <div key={i} className="why-card" style={{ background:"#f0f7ff", borderRadius:12, padding:"28px 24px", boxShadow:"0 2px 16px rgba(26,106,181,0.07)", borderBottom:"3px solid transparent", transition:"transform 0.25s, box-shadow 0.25s, border-bottom-color 0.25s", cursor:"default" }}>
                <div style={{ width:52, height:52, background:"rgba(26,106,181,0.08)", borderRadius:12, display:"flex", alignItems:"center", justifyContent:"center", marginBottom:18 }}>{item.icon}</div>
                <h3 style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:800, fontSize:19, color:"#0d3c6e", margin:"0 0 10px", textTransform:"uppercase" }}>{item.title}</h3>
                <p style={{ color:"#5a80a0", fontSize:14, lineHeight:1.75, margin:0 }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      

      {/* CTA */}
      <section style={{ background:"linear-gradient(135deg,#0d3c6e,#1a6ab5)", padding:"60px 24px", textAlign:"center" }}>
        <h2 style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:"clamp(26px,4vw,44px)", fontWeight:900, color:"#fff", margin:"0 0 12px", textTransform:"uppercase" }}>Ready to Work With Us?</h2>
        <p style={{ color:"rgba(255,255,255,0.7)", fontSize:15, margin:"0 0 28px" }}>Contact us today for a free consultation and project estimate.</p>
        <div style={{ display:"flex", gap:16, justifyContent:"center", flexWrap:"wrap" }}>
          <a href="/contact#form" style={{ background:"#e8a800", color:"#0d3c6e", fontWeight:800, fontSize:14, letterSpacing:1.5, padding:"13px 32px", borderRadius:8, textDecoration:"none", textTransform:"uppercase", transition:"background 0.2s, transform 0.15s" }}
            onMouseEnter={e => { e.currentTarget.style.background="#d09800"; e.currentTarget.style.transform="translateY(-2px)"; }}
            onMouseLeave={e => { e.currentTarget.style.background="#e8a800"; e.currentTarget.style.transform="translateY(0)"; }}
          >Get In Touch</a>
          <a href="/services" style={{ border:"2px solid rgba(255,255,255,0.5)", color:"#fff", fontWeight:700, fontSize:14, letterSpacing:1.5, padding:"13px 32px", borderRadius:8, textDecoration:"none", textTransform:"uppercase", transition:"all 0.2s" }}
            onMouseEnter={e => { e.currentTarget.style.background="rgba(255,255,255,0.1)"; e.currentTarget.style.borderColor="#fff"; }}
            onMouseLeave={e => { e.currentTarget.style.background="transparent"; e.currentTarget.style.borderColor="rgba(255,255,255,0.5)"; }}
          >View Services</a>
        </div>
      </section>

      <Footer />
    </div>
  );
}